<template>
    <div id="pop-up-ads-form">
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                {
                    text: 'Pop Up Ads',
                    to: { path: '/pop-up-ads' },
                    exact: true,
                },
                {
                    text: $route.query.id
                        ? 'Ubah Pop Up Ads'
                        : 'Tambah Pop Up Ads',
                },
            ]"
            divider="|"
        ></v-breadcrumbs>

        <h3 class="header-text font-weight-bold">
            {{ $route.query.id ? "Ubah" : "Tambah" }} Pop Up Ads
        </h3>

        <v-card style="border">
            <v-card-title> Detail Pop Up Ads </v-card-title>
            <v-divider />
            <v-card flat class="d-flex">
                <v-col cols="3" class="py-0">
                    <v-card flat>
                        <v-card-text class="pa-0 my-2">
                            <v-card
                                flat
                                class="border-bottom-divider rounded-tl pa-0"
                            >
                                <a href="javascript:;">
                                    <img
                                        :src="
                                            url
                                                ? url
                                                : data.image && data.image != ''
                                                  ? data.image
                                                  : require('@/assets/img/image_unavailable.png')
                                        "
                                        :key="keyimg"
                                    />
                                </a>
                            </v-card>
                        </v-card-text>
                        <v-card-text class="pa-0 my-2">
                            <v-btn
                                @click="$refs.uploader.click()"
                                block
                                class="pa-0 mt-5 font-weight-bold"
                                color="success"
                                depressed
                                dark
                            >
                                <v-icon class="mr-1">mdi-file-upload</v-icon>
                                Upload
                            </v-btn>

                            <input
                                type="file"
                                ref="uploader"
                                class="d-none"
                                accept="image/*"
                                @change="onFileChange"
                            />
                        </v-card-text>
                        <v-card-text
                            class="text-caption pa-0 d-flex justify-center"
                        >
                            Ukuran gambar 400 x 500
                        </v-card-text>
                        <v-card-text
                            class="text-caption pa-0 d-flex justify-center"
                        >
                            Maximum size is 300 KB
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="9" style="border-left: 1px solid #f0f0f0">
                    <v-card flat>
                        <v-card-text class="pa-0">
                            <v-list-item two-line>
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold font-size-14 pb-2"
                                    >
                                        Nama Ads
                                        <span class="red--text">*</span>
                                    </v-list-item-title>

                                    <v-text-field
                                        v-model="data.name"
                                        placeholder="Nama Ads"
                                        required
                                        outlined
                                        dense
                                    />
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item two-line>
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold font-size-14 pb-2"
                                    >
                                        Deskripsi
                                        <span class="red--text">*</span>
                                    </v-list-item-title>
                                    <v-textarea
                                        placeholder="Deskripsi Kelas"
                                        v-model="data.deskripsi"
                                        outlined
                                        dense
                                    />
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item two-line>
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold font-size-14 pb-2"
                                    >
                                        URL <span class="red--text">*</span>
                                    </v-list-item-title>

                                    <v-text-field
                                        v-model="data.url"
                                        placeholder="https://"
                                        required
                                        outlined
                                        dense
                                    />
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item two-line>
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold font-size-14 pb-2"
                                    >
                                        Deeplink URL
                                        <span class="red--text">*</span>
                                    </v-list-item-title>

                                    <v-text-field
                                        v-model="data.deeplink"
                                        placeholder="https://"
                                        required
                                        outlined
                                        dense
                                    />
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item two-line>
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold font-size-14 pb-2"
                                    >
                                        Page Direction
                                        <span class="red--text">*</span>
                                    </v-list-item-title>

                                    <v-text-field
                                        v-model="data.page_direction"
                                        placeholder="https://"
                                        required
                                        outlined
                                        dense
                                    />
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                                <v-row>
                                    <v-col cols="6">
                                        <v-list-item two-line class="py-0 px-1">
                                            <v-list-item-content>
                                                <v-list-item-title
                                                    class="font-weight-bold font-size-14 pb-2"
                                                >
                                                    Waktu Mulai
                                                    <span class="red--text"
                                                        >*</span
                                                    >
                                                </v-list-item-title>
                                                <v-container>
                                                    <v-row>
                                                        <v-col cols="6">
                                                            <v-menu
                                                                ref="menu"
                                                                v-model="
                                                                    startDate.option
                                                                "
                                                                :close-on-content-click="
                                                                    false
                                                                "
                                                                transition="slide-y-reverse-transition"
                                                                offset-y
                                                                min-width="auto"
                                                            >
                                                                <template
                                                                    v-slot:activator="{
                                                                        on,
                                                                        attrs,
                                                                    }"
                                                                >
                                                                    <v-text-field
                                                                        id="tryout_durasi_start_date"
                                                                        v-model="
                                                                            startDate.value
                                                                        "
                                                                        append-icon="mdi-calendar"
                                                                        placeholder="Tanggal"
                                                                        v-bind="
                                                                            attrs
                                                                        "
                                                                        v-on="
                                                                            on
                                                                        "
                                                                        outlined
                                                                        dense
                                                                    ></v-text-field>
                                                                </template>
                                                                <v-date-picker
                                                                    v-if="
                                                                        startDate.option
                                                                    "
                                                                    v-model="
                                                                        startDate.value
                                                                    "
                                                                    :min="
                                                                        new Date()
                                                                            .toISOString()
                                                                            .slice(
                                                                                0,
                                                                                10,
                                                                            )
                                                                    "
                                                                    no-title
                                                                    scrollable
                                                                    dense
                                                                    @change="
                                                                        startDate.option = false
                                                                    "
                                                                >
                                                                </v-date-picker>
                                                            </v-menu>
                                                        </v-col>
                                                        <v-col cols="6">
                                                            <v-menu
                                                                ref="menu1"
                                                                v-model="
                                                                    startTime.option
                                                                "
                                                                :close-on-content-click="
                                                                    false
                                                                "
                                                                :nudge-right="
                                                                    40
                                                                "
                                                                transition="slide-y-reverse-transition"
                                                                offset-y
                                                                max-width="290px"
                                                                min-width="290px"
                                                            >
                                                                <template
                                                                    v-slot:activator="{
                                                                        on,
                                                                        attrs,
                                                                    }"
                                                                >
                                                                    <v-text-field
                                                                        id="tryout_durasi_start_time"
                                                                        v-model="
                                                                            startTime.value
                                                                        "
                                                                        outlined
                                                                        dense
                                                                        placeholder="Jam"
                                                                        append-icon="mdi-clock-time-four-outline"
                                                                        v-bind="
                                                                            attrs
                                                                        "
                                                                        v-on="
                                                                            on
                                                                        "
                                                                    ></v-text-field>
                                                                </template>
                                                                <v-time-picker
                                                                    v-if="
                                                                        startTime.option
                                                                    "
                                                                    v-model="
                                                                        startTime.value
                                                                    "
                                                                    format="24hr"
                                                                    @change="
                                                                        startTime.value =
                                                                            startTime.value
                                                                                ? startTime.value +
                                                                                  ':00'
                                                                                : null
                                                                    "
                                                                    @click:minute="
                                                                        $refs.menu1.save(
                                                                            startTime.value,
                                                                        )
                                                                    "
                                                                ></v-time-picker>
                                                            </v-menu>
                                                        </v-col>
                                                    </v-row>
                                                </v-container>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-list-item two-line class="py-0 px-1">
                                            <v-list-item-content>
                                                <v-list-item-title
                                                    class="font-weight-bold font-size-14 pb-2"
                                                >
                                                    Waktu Berakhir
                                                    <span class="red--text"
                                                        >*</span
                                                    >
                                                </v-list-item-title>
                                                <v-container>
                                                    <v-row>
                                                        <v-col cols="6">
                                                            <v-menu
                                                                ref="menu"
                                                                v-model="
                                                                    endDate.option
                                                                "
                                                                :close-on-content-click="
                                                                    false
                                                                "
                                                                transition="slide-y-reverse-transition"
                                                                offset-y
                                                                min-width="auto"
                                                            >
                                                                <template
                                                                    v-slot:activator="{
                                                                        on,
                                                                        attrs,
                                                                    }"
                                                                >
                                                                    <v-text-field
                                                                        id="tryout_durasi_end_date"
                                                                        v-model="
                                                                            endDate.value
                                                                        "
                                                                        append-icon="mdi-calendar"
                                                                        placeholder="Tanggal"
                                                                        v-bind="
                                                                            attrs
                                                                        "
                                                                        v-on="
                                                                            on
                                                                        "
                                                                        outlined
                                                                        dense
                                                                    ></v-text-field>
                                                                </template>
                                                                <v-date-picker
                                                                    v-if="
                                                                        endDate.option
                                                                    "
                                                                    v-model="
                                                                        endDate.value
                                                                    "
                                                                    :min="
                                                                        new Date()
                                                                            .toISOString()
                                                                            .slice(
                                                                                0,
                                                                                10,
                                                                            )
                                                                    "
                                                                    no-title
                                                                    scrollable
                                                                    @change="
                                                                        endDate.option = false
                                                                    "
                                                                >
                                                                </v-date-picker>
                                                            </v-menu>
                                                        </v-col>
                                                        <v-col cols="6">
                                                            <v-menu
                                                                ref="menu"
                                                                v-model="
                                                                    endTime.option
                                                                "
                                                                :close-on-content-click="
                                                                    false
                                                                "
                                                                :nudge-right="
                                                                    40
                                                                "
                                                                transition="slide-y-reverse-transition"
                                                                offset-y
                                                                max-width="290px"
                                                                min-width="290px"
                                                            >
                                                                <template
                                                                    v-slot:activator="{
                                                                        on,
                                                                        attrs,
                                                                    }"
                                                                >
                                                                    <v-text-field
                                                                        id="tryout_durasi_end_time"
                                                                        v-model="
                                                                            endTime.value
                                                                        "
                                                                        outlined
                                                                        dense
                                                                        placeholder="Jam"
                                                                        append-icon="mdi-clock-time-four-outline"
                                                                        v-bind="
                                                                            attrs
                                                                        "
                                                                        v-on="
                                                                            on
                                                                        "
                                                                    ></v-text-field>
                                                                </template>
                                                                <v-time-picker
                                                                    v-if="
                                                                        endTime.option
                                                                    "
                                                                    v-model="
                                                                        endTime.value
                                                                    "
                                                                    format="24hr"
                                                                    @change="
                                                                        endTime.value =
                                                                            endTime.value
                                                                                ? endTime.value +
                                                                                  ':00'
                                                                                : null
                                                                    "
                                                                    @click:minute="
                                                                        $refs.menu.save(
                                                                            endTime.value,
                                                                        )
                                                                    "
                                                                ></v-time-picker>
                                                            </v-menu>
                                                        </v-col>
                                                    </v-row>
                                                </v-container>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-col>
                                </v-row>
                            </v-list-item>
                            <v-list-item two-line>
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold font-size-14 pb-2"
                                    >
                                        Status Aktif
                                    </v-list-item-title>
                                    <div class="d-inline">
                                        <v-checkbox
                                            label="Aktif"
                                            v-model="data.is_active"
                                            class="pa-2 ma-0 d-inline-flex"
                                            outlined
                                        />
                                    </div>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item two-line>
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold font-size-14 pb-2"
                                    >
                                        Tampilkan di Platform
                                    </v-list-item-title>
                                    <div class="d-inline">
                                        <v-checkbox
                                            label="Android"
                                            v-model="data.is_android"
                                            class="pa-2 ma-0 d-inline-flex"
                                            outlined
                                        />

                                        <v-checkbox
                                            label="IOS"
                                            v-model="data.is_ios"
                                            class="pa-2 ma-0 d-inline-flex"
                                            outlined
                                        />

                                        <v-checkbox
                                            label="Webapp"
                                            v-model="data.is_webapp"
                                            class="pa-2 ma-0 d-inline-flex"
                                            outlined
                                        />

                                        <v-checkbox
                                            label="Web Purchase"
                                            v-model="data.is_webpurchase"
                                            class="pa-2 ma-0 d-inline-flex"
                                            outlined
                                        />
                                    </div>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item two-line>
                                <v-list-item-content class="pt-0 px-0 pb-6">
                                    <v-list-item-title
                                        class="font-weight-bold font-size-14 pb-2"
                                    >
                                        User Group
                                        <span class="red--text">*</span>
                                    </v-list-item-title>
                                    <v-autocomplete
                                        :items="user_groups"
                                        item-text="user_group_name"
                                        item-value="id"
                                        class="pb-2"
                                        placeholder="-- Pilih user group --"
                                        outlined
                                        dense
                                        v-for="(usgr, i) in data.user_group"
                                        :key="i"
                                        v-model="data.user_group[i]"
                                    >
                                        <template v-slot:append-outer>
                                            <v-btn
                                                id="user-remove-scope-btn"
                                                dark
                                                x-large
                                                class="font-weight-bold dark--text py-3"
                                                depressed
                                                color="white"
                                                elevation="1"
                                                v-if="
                                                    i ===
                                                        data.user_group.length -
                                                            1 &&
                                                    data.user_group.length != 1
                                                "
                                                @click="
                                                    queryId
                                                        ? null
                                                        : data.user_group.splice(
                                                              i,
                                                              1,
                                                          )
                                                "
                                            >
                                                Hapus
                                            </v-btn>
                                        </template>
                                    </v-autocomplete>
                                </v-list-item-content>
                            </v-list-item>
                            <v-container>
                                <v-btn
                                    id="user-add-scope-btn"
                                    @click="data.user_group.push('')"
                                    block
                                    depressed
                                    class="font-weight-bold blew--text mb-5"
                                    color="#e8f5fa"
                                >
                                    <v-icon
                                        style="font-size: 16px !important"
                                        class="mr-1"
                                    >
                                        mdi-plus-circle
                                    </v-icon>
                                    Tambah User Group Baru
                                </v-btn>
                                <v-btn
                                    block
                                    v-if="$route.query.id"
                                    class="font-weight-bold blew--text mb-5"
                                    depressed
                                    color="#e8f5fa"
                                    @click="(pushNew(), fetchData())"
                                >
                                    <v-icon
                                        style="font-size: 22px !important"
                                        class="mr-1"
                                    >
                                        mdi-sort-bool-ascending-variant
                                    </v-icon>
                                    Atur Urutan Pop Up Ads
                                </v-btn>
                            </v-container>
                        </v-card-text>
                        <v-card-actions class="pa-4">
                            <v-spacer></v-spacer>
                            <v-btn
                                depressed
                                class="px-6 py-2 white--text"
                                color="blew"
                                :loading="isLoading"
                                @click="putObject()"
                                >Simpan</v-btn
                            >
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-card>
        </v-card>

        <v-dialog v-model="dialogConfirm.open" persistent max-width="506px">
            <v-card>
                <v-card-title
                    class="text-h5"
                    style="word-break: break-word !important"
                >
                    {{ dialogConfirm.title }}
                </v-card-title>
                <v-card-text>
                    {{ dialogConfirm.subtitle }}
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="darkFade"
                        text
                        @click="
                            dialogConfirm.open = false;
                            dialogConfirm.title = null;
                            dialogConfirm.function = null;
                        "
                    >
                        Batal
                    </v-btn>
                    <v-btn
                        color="blew"
                        text
                        @click="
                            putObject(1);
                            dialogConfirm.open = false;
                            dialogConfirm.title = null;
                            dialogConfirm.function = null;
                        "
                    >
                        OK
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="modalUrutan"
            transition="dialog-top-transition"
            width="940px"
            min-height="537px"
            max-height="771px"
            scrollable
            @click:outside="modalUrutan = false"
        >
            <template v-slot:default="dialog">
                <v-card>
                    <v-card-title>
                        Urutan Pop Up Ads
                        <span v-if="data.name" class="ml-2">
                            ({{ data.name }})
                        </span>
                        <v-spacer></v-spacer>

                        <v-progress-circular
                            v-if="loading_sequence"
                            indeterminate
                            color="primary"
                            :size="30"
                        ></v-progress-circular>

                        <v-icon
                            v-if="updated_sequence && !loading_sequence"
                            color="blew"
                            style="font-size: 32px"
                            >mdi-check-circle</v-icon
                        >
                    </v-card-title>
                    <v-card-subtitle>
                        <div>Atur urutan dengan drag list pop up ads</div>
                    </v-card-subtitle>

                    <v-card-text width="100%">
                        <div class="mt-3 mb-5 pl-4 font-weight-bold">
                            <template>
                                <v-row>
                                    <v-col cols="2">Nomor Urut</v-col>
                                    <v-col cols="8">Nama Pop Up Ads</v-col>
                                </v-row>
                            </template>
                        </div>
                        <div v-if="isLoading" class="mt-8">
                            <v-skeleton-loader
                                v-bind="attrs"
                                type="card"
                            ></v-skeleton-loader>
                        </div>
                        <div v-if="!isLoading">
                            <draggable
                                :list="popup2"
                                class="list-group"
                                ghost-class="ghost"
                                :move="checkMove"
                                @start="dragging = true"
                                @end="finishDragged"
                            >
                                <div
                                    class="list-group-item pa-6 draggable"
                                    v-for="(element, index) in popup2"
                                    :class="
                                        element.id == $route.query.id
                                            ? 'selected'
                                            : ''
                                    "
                                    :key="element.id"
                                >
                                    <v-row>
                                        <v-col cols="2" md="2">
                                            <v-btn
                                                :color="
                                                    element.id ==
                                                    $route.query.id
                                                        ? '#29b6f6'
                                                        : 'blew'
                                                "
                                                class="font-weight-bold"
                                                style="font-size: 14px"
                                                rounded
                                                fab
                                                x-small
                                                dark
                                                depressed
                                            >
                                                {{ index + 1 }}
                                            </v-btn>
                                        </v-col>
                                        <v-col cols="8" md="8" class="pt-1">
                                            {{ element.name }}
                                        </v-col>
                                    </v-row>
                                </div>

                                <div class="text-center" v-if="!popup2.length">
                                    Pop Up Ads tidak tersedia
                                </div>
                            </draggable>
                        </div>

                        <v-simple-table class="pa-0" style="display: none">
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th class="text-left">Nomor Urut</th>
                                        <th class="text-left" width="80%">
                                            Nama Pop Up Ads
                                        </th>
                                        <th class="text-left">Aksi</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="(popup, index) in sortedPopUp"
                                        :key="index"
                                        :color="
                                            popup.id == $route.query.id ||
                                            popup.name === name
                                                ? '#F9F9FB'
                                                : ''
                                        "
                                    >
                                        <td>{{ popup.no_urut }}</td>
                                        <td>{{ popup.name }}</td>
                                        <td>
                                            <v-btn
                                                class="pa-0"
                                                min-width="32px"
                                                height="32px"
                                                elevation="0"
                                                v-if="
                                                    popup.no_urut > 1 &&
                                                    (popup.id ==
                                                        $route.query.id ||
                                                        popup.new)
                                                "
                                                @click="moveUp(popup)"
                                            >
                                                <v-icon>mdi-menu-up</v-icon>
                                            </v-btn>
                                            <v-btn
                                                class="pa-0"
                                                min-width="32px"
                                                height="32px"
                                                elevation="0"
                                                v-if="
                                                    popup.id ==
                                                        $route.query.id ||
                                                    popup.new
                                                "
                                                @click="moveDown(popup)"
                                            >
                                                <v-icon>mdi-menu-down</v-icon>
                                            </v-btn>
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-card-text>
                    <v-card-text>
                        <div class="text-h2"></div>
                    </v-card-text>
                    <v-card-actions class="justify-end">
                        <v-btn text @click="dialog.value = false">Close</v-btn>
                    </v-card-actions>
                </v-card>
            </template>
        </v-dialog>
    </div>
</template>

<script>
import Spinner from "@/components/plugins/Spinner";
import axios from "axios";
import Moment from "moment";
import PopUpAdsService from "@/modules/pop_up_ads/services/pop_up_ads.js";
import draggable from "vuedraggable";

export default {
    name: "pop-up-ads-form",

    components: {
        "app-spinner": Spinner,
        draggable,
    },

    data: function () {
        return {
            errors: [],
            isLoading: false,
            modalUrutan: false,
            startDate: {
                option: false,
                value: null,
            },
            endDate: {
                option: false,
                value: null,
            },
            startTime: {
                option: false,
                value: null,
            },
            endTime: {
                option: false,
                value: null,
            },
            queryId: null,
            selectedPicture: null,
            data: {
                id: null,
                name: "",
                image: null,
                deskripsi: "",
                url: "",
                deeplink: "",
                page_direction: "",
                is_active: false,
                is_ios: false,
                is_android: false,
                is_webapp: false,
                is_webpurchase: false,
                user_group: [],
            },
            dialogConfirm: {
                open: false,
                title: null,
                subtitle: null,
                function: null,
            },
            url: null,
            imageFile: null,
            user_groups: [],
            popups: [],
            popup2: [],
            no_urut: null,
            lastSequence: 0,
            dragging: false,
            list_sorted_pop_up: [],
            updated_sequence: false,
            loading_sequence: false,
            selected_sort_class: null,
        };
    },

    computed: {
        sortedPopUp() {
            return _.orderBy(this.popup2, ["no_urut"], ["asc"]);
        },

        draggingInfo() {
            return this.dragging ? "under drag" : "";
        },
    },

    mounted: function () {
        this.getUserGroupData();
        if (this.$route.query.id) this.getPopUpDetail();
    },

    methods: {
        onFileChange(e) {
            const file = e.target.files[0];

            if (file.size > 300000) {
                this.$store.commit("showAlert", {
                    message: `File lebih besar dari 300 KB!`,
                    type: "error",
                });
                return;
            }

            this.imageFile = file;
            this.keyimg++;
            this.url = URL.createObjectURL(file);
        },

        async putObject() {
            var file = this.imageFile;
            const context = this;

            context.isLoading = true;
            if (this.validateForm()) {
                var file = this.imageFile;
                if (this.data.image && !file) {
                    this.url = this.data.image;
                    this.save();
                } else {
                    if (!file) return;
                    try {
                        var filename = `${file.name
                            .split(".")
                            .slice(0, -1)
                            .join(".")}_${+new Date()}.${file.name.substring(
                            file.name.lastIndexOf(".") + 1,
                            file.name.length,
                        )}`;
                        let result = await this.$alioss.put(
                            `assets/notification/${filename}`,
                            file,
                        );
                        await this.$alioss.putACL(
                            `assets/notification/${filename}`,
                            "public-read",
                        );
                        context.url = result.url;
                        context.data.image = result.url;
                        context.save();
                    } catch (error) {
                        alert("terjadi kesalahan : " + error);
                        context.isLoading = false;
                    }
                }
            } else this.isLoading = false;
        },

        save() {
            var context = this;

            if (this.validateForm()) {
                if (this.$route.query.id) {
                    var userGroup = [];
                    context.data.user_group.forEach(function (group) {
                        if (group.id) {
                            userGroup.push(group.id);
                        } else {
                            userGroup.push(group);
                        }
                    });

                    var postData = {
                        name: context.data.name,
                        deskripsi: context.data.deskripsi,
                        url: context.data.url,
                        deeplink: context.data.deeplink,
                        page_direction: context.data.page_direction,
                        image: context.data.image,
                        start_at: context.startDate.value,
                        end_at: context.endDate.value,
                        start_time: context.startTime.value,
                        end_time: context.endTime.value,
                        user_group: userGroup,
                        is_ios: context.data.is_ios,
                        is_active: context.data.is_active,
                        is_android: context.data.is_android,
                        is_webapp: context.data.is_webapp,
                        is_webpurchase: context.data.is_webpurchase,
                    };

                    PopUpAdsService.updatePopUpAds(
                        context.$route.query.id,
                        postData,
                        function (response) {
                            if (response.success) {
                                if (!response.data.status === 200) {
                                    context.$store.commit("showAlert", {
                                        message: `Gagal menyimpan data!`,
                                        type: "error",
                                    });
                                } else {
                                    context.$store.commit("showAlert", {
                                        message: `Berhasil menyimpan data!`,
                                        type: "success",
                                    });
                                    context.isLoading = false;
                                    context.$router.push("/pop-up-ads");
                                }
                            } else {
                                context.$store.commit("showAlert", {
                                    message: `Gagal menyimpan!`,
                                    type: "error",
                                });
                            }

                            context.isLoading = false;
                        },
                    );
                } else {
                    var postData = {
                        name: context.data.name,
                        deskripsi: context.data.deskripsi,
                        url: context.data.url,
                        deeplink: context.data.deeplink,
                        page_direction: context.data.page_direction,
                        image: context.data.image,
                        start_at: context.startDate.value,
                        end_at: context.endDate.value,
                        start_time: context.startTime.value,
                        end_time: context.endTime.value,
                        user_group: context.data.user_group,
                        is_ios: context.data.is_ios,
                        is_active: context.data.is_active,
                        is_android: context.data.is_android,
                        is_webapp: context.data.is_webapp,
                        is_webpurchase: context.data.is_webpurchase,
                    };

                    PopUpAdsService.createPopUpAds(
                        postData,
                        function (response) {
                            if (response.success) {
                                if (
                                    response.data.description ==
                                    "Failed to Record Data"
                                ) {
                                    context.$store.commit("showAlert", {
                                        message: `Gagal menyimpan data!`,
                                        type: "error",
                                    });
                                } else {
                                    context.$store.commit("showAlert", {
                                        message: `Berhasil menyimpan data!`,
                                        type: "success",
                                    });
                                    context.isLoading = false;
                                    context.$router.push("/pop-up-ads");
                                }
                            } else {
                                context.$store.commit("showAlert", {
                                    message: `Gagal menyimpan!`,
                                    type: "error",
                                });
                            }

                            context.isLoading = false;
                        },
                    );
                }
            } else {
                this.isLoading = false;
            }
        },

        handleChangePicture: function (event) {
            const file = event.target.files[0];
            this.selectedPicture = file;
            this.data.picture = URL.createObjectURL(file);
        },

        moveUp: function (popUpDetail) {
            const itemIndex = this.popup2.findIndex(
                (s) => popUpDetail.id === s.id,
            );
            this.no_urut = popUpDetail.no_urut - 1;
            this.popup2[itemIndex].no_urut = this.no_urut;
            this.changeSequence(popUpDetail.id, this.no_urut);
        },

        moveDown: function (popUpDetail) {
            const itemIndex = this.popup2.findIndex(
                (s) => popUpDetail.id === s.id,
            );
            this.no_urut = popUpDetail.no_urut + 1;
            this.popup2[itemIndex].no_urut = this.no_urut;
            this.changeSequence(popUpDetail.id, this.no_urut);
        },

        changeSequence(id, nomor) {
            var context = this;
            var body = context.list_sorted_pop_up;
            context.loading_sequence = true;
            context.updated_sequence = false;

            PopUpAdsService.changeSequence(body, function (result) {
                if (result.success) {
                    context.updated_sequence = true;
                    context.$store.commit("showAlert", {
                        message: `Berhasil Mengubah Urutan Pop Up Ads!`,
                        type: "success",
                    });
                } else {
                    console.log(result);
                    context.$store.commit("showAlert", {
                        message: `Terjadi kesalahan`,
                        submessage: "Urutan Pop Up Ads tidak berubah",
                        type: "error",
                    });
                }

                setTimeout(() => {
                    context.loading_sequence = false;
                }, 1000);
            });
        },

        pushNew() {
            var found = this.popup2.find((e) => e.id == this.$route.query.id);
            if (!found) {
                var data = this.popups;
                this.popup2.push(data);
                this.popup2 = _.orderBy(this.popup2, ["sequence"], ["asc"]);
                this.lastSequence = this.popup2.length;
            }
        },

        checkMove: function (e) {
            window.console.log("Future index: " + e.draggedContext.futureIndex);
        },

        finishDragged() {
            this.dragging = false;
            this.list_sorted_pop_up = [];

            this.popup2.map((res, index) => {
                var no_urut = index + 1;

                this.list_sorted_pop_up.push({
                    pop_ads_id: res.id,
                    no_urut: no_urut,
                });

                if (res.id === this.$route.query.id) {
                    this.no_urut = no_urut;
                }
            });

            this.changeSequence();
        },

        fetchData: function () {
            this.modalUrutan = true;

            var context = this;
            context.isLoading = true;

            try {
                PopUpAdsService.getListPopUpAds((result) => {
                    context.popups = [];
                    context.popup2 = [];

                    if (result.success) {
                        context.popups = result.data;
                        result.data.forEach((e) => {
                            context.popup2.push(e);
                        });
                        context.popup2 = _.orderBy(
                            context.popup2,
                            ["no_urut"],
                            ["asc"],
                        );
                        context.lastSequence = context.popup2.length;
                    }
                    context.isLoading = false;
                });
            } catch (error) {
                context.isLoading = false;
            }
        },

        validateForm() {
            var err = false;
            if (!this.data.name) {
                this.$store.commit("showAlert", {
                    message: `Nama Ads wajib diisi!`,
                    type: "error",
                });
                err = true;
            }

            if (this.data.page_direction.slice(0, 5) !== "https") {
                this.$store.commit("showAlert", {
                    message: `Page Direction harus di awali dengan https!`,
                    type: "error",
                });
                err = true;
            }

            if (this.data.url.slice(0, 5) !== "https") {
                this.$store.commit("showAlert", {
                    message: `Input URL harus di awali dengan https!`,
                    type: "error",
                });
                err = true;
            }

            if (!this.data.deskripsi) {
                this.$store.commit("showAlert", {
                    message: `Deskripsi wajib diisi!`,
                    type: "error",
                });
                err = true;
            }

            if (!this.data.url) {
                this.$store.commit("showAlert", {
                    message: `URL wajib diisi!`,
                    type: "error",
                });
                err = true;
            }

            if (!this.data.deeplink) {
                this.$store.commit("showAlert", {
                    message: `Deeplink wajib diisi!`,
                    type: "error",
                });
                err = true;
            }

            if (!this.data.page_direction) {
                this.$store.commit("showAlert", {
                    message: `Page Direction wajib diisi!`,
                    type: "error",
                });
                err = true;
            }

            if (!this.startDate.value) {
                this.$store.commit("showAlert", {
                    message: `Waktu Mulai wajib diisi!`,
                    type: "error",
                });
                err = true;
            }

            if (!this.endDate.value) {
                this.$store.commit("showAlert", {
                    message: `Waktu Berakhir wajib diisi!`,
                    type: "error",
                });
                err = true;
            }

            if (this.data.user_group.length == 0) {
                this.$store.commit("showAlert", {
                    message: `User Group wajib diisi!`,
                    type: "error",
                });
                err = true;
            }

            if (!this.imageFile && !this.data.image) {
                this.$store.commit("showAlert", {
                    message: `Wajib upload gambar!`,
                    type: "error",
                });
                err = true;
            }
            return !err;
        },

        characterCounter: function (text) {
            text = text.replace(/<[^>]*>/g, "");
            text = text.replace(/\&nbsp;/g, " ");
            return text.length;
        },

        async getPopUpDetail() {
            const context = this;
            context.isLoading = true;
            await PopUpAdsService.getDetailPopUpAds(
                this.$route.query.id,
                function (response) {
                    if (response.success) {
                        context.data = response.data;
                        context.data.deskripsi = response.data.description;
                        context.data.url = response.data.external_url;
                        context.startDate.value = Moment(
                            response.data.start_date,
                        ).format("YYYY-MM-DD");
                        context.startTime.value = response.data.start_time;
                        context.endDate.value = Moment(
                            response.data.end_date,
                        ).format("YYYY-MM-DD");
                        context.endTime.value = response.data.end_time;
                    } else {
                        context.$store.commit("showAlert", {
                            message: `Gagal mengambil data pop up!`,
                            type: "error",
                        });
                    }
                    context.isLoading = false;
                },
            );
        },

        getUserGroupData() {
            this.user_groups = [];
            const url =
                process.env.API_BASE_URL +
                "/payment/list/user_group?page=1&per_page=1000";

            const authToken = JSON.parse(localStorage.getItem("token")).value;
            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };
            const context = this;
            axios.get(url, options).then(function (response) {
                if (response.status === 200) {
                    context.user_groups = response.data.user_groups;
                }
            });
        },

        getUniqueListBy(arr) {
            // return [...new Map(arr.map((item) => [item[key], item])).values()];
            return arr.filter(
                (value, index, array) => array.indexOf(value) === index,
            );
        },
    },
};
</script>

<style>
.ck-content {
    min-height: 120px;
}

.draggable {
    cursor: all-scroll !important;
}

.selected {
    background-color: #00897b;
    color: #fff !important;
}

.ghost {
    opacity: 1;
    background: #ececec;
    cursor: all-scroll !important;
}
</style>



// WEBPACK FOOTER //
// PopUpAdsForm.vue?df711c60